import { PathLocationStrategy } from '@angular/common';

export const enforceTrailingSlashes = () => {
    /* eslint-disable @typescript-eslint/unbound-method */
    const originalPrepareExternalUrl =
        PathLocationStrategy.prototype.prepareExternalUrl;
    /* eslint-enable @typescript-eslint/unbound-method */

    PathLocationStrategy.prototype.prepareExternalUrl = function (
        internal
    ): string {
        const url = originalPrepareExternalUrl
            ? (originalPrepareExternalUrl.call(this, internal) as string)
            : internal;

        if (url === '') {
            return url;
        }

        const match = url.match(/#|\?|$/);
        const pathEndIdx = (match && match.index) || url.length;
        const path = url.slice(0, pathEndIdx);

        if (path.endsWith('/') || path.endsWith('.html')) {
            return url;
        }

        return `${path}/${url.slice(pathEndIdx)}`;
    };
};
